import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const BannerWrapper = styled.div<{ $isLoading?: boolean }>`
    padding: 8px 12px;
    margin: 8px -16px -16px;
    border-radius: 0 0 6px 6px;
    background-color: ${({ $isLoading }) => ($isLoading ? "transparent" : colorsPalettes.blue[50])};
`;

export const BannerRow = styled(Flex)`
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: max-content;
`;

export const BannerText = styled(Text)`
    display: block;
    width: 257px;
    white-space: normal;
`;

export const BannerCta = styled(Button)`
    gap: 4px;
`;
